import PropTypes from 'prop-types';
import React from 'react';

import { QuestionCircleFilled } from 'opencare-crown';

import { colors } from '../../../../common/styles/style-constants';
import {
  DIMENSIONS,
  useWindowDimensions,
} from '../../../../providers/WindowDimensionsProvider';
import {
  CopyWrapper,
  IconWrapper,
  OptionDescription,
  OptionTitle,
  StyledTooltip,
} from '../../styled-components';

import { StyledButton, Wrapper } from './styled-components';

const SingleSelect = ({
  id,
  title,
  describedBy,
  onChange,
  Icon,
  Logo,
  tooltip,
  description,
  label,
  minHeightDesktop,
  selected,
  className,
}) => {
  const { layout } = useWindowDimensions();

  const hideIcon = layout === DIMENSIONS.MOBILE && tooltip;
  const tooltipBaseColor =
    layout === DIMENSIONS.MOBILE ? colors.sage : colors.gray5;
  const fallbackLabel =
    tooltip || description ? `${title}. ${tooltip || description}` : title;

  return (
    <Wrapper id={`option-wrapper-${id}`}>
      <StyledButton
        type="button"
        id={`option-${id}`}
        data-testid={`option-${id}`}
        onClick={() => onChange(id)}
        aria-describedby={describedBy}
        minHeightDesktop={minHeightDesktop}
        aria-label={label || fallbackLabel}
        checked={selected}
        className={className}
        hasLogo={Logo}
      >
        {Logo && <Logo height={layout === DIMENSIONS.MOBILE ? '30' : '56'} />}
        {Icon && !hideIcon
          && (
            <IconWrapper aria-hidden>
              <Icon color={colors.sage6} style={{ color: colors.sage6 }} />
            </IconWrapper>
          )}
        {tooltip
          && (
            <StyledTooltip title={tooltip} aria-hidden>
              <QuestionCircleFilled
                style={{ color: selected ? colors.sage5 : tooltipBaseColor }}
              />
            </StyledTooltip>
          )}
        {!Logo
          && (
            <CopyWrapper aria-hidden>
              <OptionTitle>{title}</OptionTitle>
              {description
                && <OptionDescription>{description}</OptionDescription>}
            </CopyWrapper>
          )}
      </StyledButton>
    </Wrapper>
  );
};

SingleSelect.defaultProps = {
  Icon: null,
  Logo: null,
  tooltip: null,
  description: null,
  label: '',
  selected: false,
};

SingleSelect.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  title: PropTypes.string.isRequired,
  describedBy: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  Icon: PropTypes.elementType,
  Logo: PropTypes.elementType,
  tooltip: PropTypes.string,
  description: PropTypes.string,
  label: PropTypes.string,
  minHeightDesktop: PropTypes.string,
  selected: PropTypes.bool,
  className: PropTypes.string,
};

export default SingleSelect;
